import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import actions from '../constants';
import CohortCreatedToast from '../components/CohortCreatedToast';

export function* editCohortSuccessToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* newCohortToast({ result }) {
  yield call(showToast, <CohortCreatedToast code={result.code} name={result.name} />);
}

export function* destroyCohortToast({ items, silent }) {
  if (!silent) {
    yield call(showToast, <DeletesToast items={items} />);
  }
}

export function* destroyCohortErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export default function* cohortToasts() {
  yield takeEvery(actions.EDIT_COHORT_SUCCESS, editCohortSuccessToast);
  yield takeEvery(actions.NEW_COHORT, newCohortToast);
  yield takeEvery(actions.DESTROY_COHORT, destroyCohortToast);
  yield takeEvery(actions.DESTROY_COHORT_ERROR, destroyCohortErrorToast);
}
